import { Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Header = styled(Box)(({ theme }) => {
  return {
    width: "100%",
    backgroundColor: theme.customColors.backgroundPrimaryLighter,
    borderBottom: `1px solid ${theme.customColors.border}`
  };
});

export const DescriptionPlayerContainer = styled(Box)<{$isMobile: boolean}>(({ $isMobile }) => {
  return {
    borderRadius: "24px",
    overflow: "hidden",
    flexGrow: 1,
    height: "420px",
    width: $isMobile ? "100%" : "auto",
    backgroundColor: "black"
  };
});

export const ArchitectureListContainer = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "86px",
    flexWrap: "wrap",
    [theme.breakpoints.down(1366)]: {
      gap: "32px"
    }
  };
});

export const ArchitectureCard = styled(Box)<{$isFirst: boolean}>(({ theme, $isFirst }) => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "280px",
    height: "280px",
    padding: "48px 32px",
    borderRadius: "24px",
    gap: "17px",
    backgroundColor: $isFirst ? theme.customColors.backgroundPrimaryCta : "transparent",
    border: `2px solid ${$isFirst ? "transparent" : theme.customColors.border}`,
    boxShadow: "0 25px 50 0 #0000001A",
    color: $isFirst ? theme.customColors.textPrimaryCta : theme.customColors.backgroundPrimaryCta
  };
});

export const ArchitectureCardArrowSeparator = styled(Box)(({ theme }) => {
  return {
    display: "block",
    [theme.breakpoints.down(1366)]: {
      display: "none"
    }
  };
});

export const ArchitectureCardIconContainer = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "999px",
    flexShrink: 0,
    backgroundColor: alpha(theme.customColors.backgroundSecondary, 0.1),
    width: "80px",
    height: "80px"
  };
});

export const GovernanceListContainer = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap:  "24px",
    marginTop: "32px",
    flexWrap: "wrap",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  };
});

export const GovernanceCard = styled(Box)(({ theme }) => {
  return {
    border: `2px solid ${theme.customColors.border}`,
    padding: "25px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent:  "center",
    alignItems: "start",
    gap: "15px",
    width: "325px",
    color: theme.customColors.exploreCardText
  };
});

export const GovernanceCardIndexContainer = styled(Box)(({ theme }) => {
  return {
    borderRadius: "999px",
    backgroundColor: theme.customColors.backgroundPrimaryCta,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    color: "white"
  };
});

export const FacultyCard = styled(Box)(({ theme }) => {
  return {
    borderRadius: "20px",
    position: "relative",
    height: "320px",
    overflow: "hidden",
    border: `2px solid ${theme.customColors.border}` 
  };
});

export const FacultyCardOverlay = styled(Box)(({ theme }) => {
  return {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: theme.linearGradients.gradientCarouselCard
  };
});

export const FacultyCardContent = styled(Box)(({ theme }) => {
  return {
    position: "absolute",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    color: theme.customColors.exploreCardText
  };
});

export const ValuesContainer = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "24px",
    flexWrap: "wrap",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  };
});

export const ValueCard = styled(Box)<{$isMobile: boolean}>(({ theme, $isMobile }) => {
  return {
    padding: "48px 16px",
    borderRadius: "20px",
    backgroundColor: theme.customColors.backgroundPrimary,
    boxShadow: "0 25px 50px 0 #0000001A",
    height: $isMobile ? "auto" : "400px",
    width: "250px",
    color: theme.customColors.textPrimary,
    textAlign: "center"
  };
});

export const Container = styled(Box)<{$isMobile?: boolean}>(({ $isMobile }) => {
  return {
    maxWidth: $isMobile ? "100%" : "1440px",
    padding: "8px 40px",
    margin: "auto",
    width: "100%"
  };
});
